"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoomiOrderNewInvoiceSchema = void 0;
const boomi_order_default_1 = require("./boomi-order-default");
const EVENT_INFO_DEFINITION = {
    properties: {
        autoRenewStatus: {
            type: 'boolean'
        },
        isTrial: {
            type: 'boolean'
        },
        didBillingRecover: {
            type: 'boolean'
        },
        didSubscriptionRestart: {
            type: 'boolean'
        },
        expiresDate: {
            type: 'string',
            minLength: 10
        },
        autoRenewStatusChangeDate: {
            type: 'string',
            minLength: 10
        },
    },
    required: [
        'autoRenewStatus',
        'isTrial',
        'expiresDate'
    ],
    type: 'object',
};
const EVENT_INFO_PROPERTY = {
    $ref: '#/definitions/EventInfo'
};
const EVENT_TYPE_DEFINITION = {
    enum: [
        'NEW_INVOICE',
    ],
    type: 'string'
};
const EVENT_TYPE_PROPERTY = {
    $ref: '#/definitions/EventType'
};
exports.BoomiOrderNewInvoiceSchema = {
    ...boomi_order_default_1.BoomiOrderDefaultSchema,
    definitions: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.definitions,
        EventInfo: EVENT_INFO_DEFINITION,
        EventType: EVENT_TYPE_DEFINITION,
    },
    properties: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.properties,
        eventInfo: EVENT_INFO_PROPERTY,
        eventType: EVENT_TYPE_PROPERTY,
    }
};
//# sourceMappingURL=data:application/json;base64,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